import image1 from "../images/courses-list/master_avanzado.png";
import image2 from "../images/courses-list/ricardo-diaz-3demongirlda.jpg";
import image3 from "../images/courses-list/ricardo-diaz-c1.jpg";

const previewCourses = [
    {
        backgroundImage: image1,
        number: "01",
        course: "master avanzado",
    },
    {
        backgroundImage: image2,
        number: "02",
        course: "curso blender",
    },
    {
        backgroundImage: image3,
        number: "03",
        course: "curso zbrush",
    },
];

export default previewCourses;
